import { z } from "zod"

import { ZodFormObjectTypeDescription } from "@tfg/types/constants/zodFromInputTypes"

export const FormFileSchema = z
  .object({
    name: z.string(),
    url: z.string().nullable(),
    path: z.string(),
  })
  .describe(ZodFormObjectTypeDescription.ZOD_FILE)

export type FormFileType = z.infer<typeof FormFileSchema>
